module.exports = __webpack_public_path__ + "static/studentsports_about-ef3eedc5f55c845bc912e5041bedc73e.jpg";